// ！！！！！此处BASEURL不再使用

// 测试环境
// const BASEURL = '//cyx-test.jiancehulian.com/'
// 正式环境
const BASEURL = '//cyx.jiancehulian.com/'
// garvey 电脑
// const BASEURL = '//192.168.1.198:6000/'
export default{
    install(Vue,options)
    {
        Vue.prototype.BASEURL = BASEURL;
    }
}




// isProfessional: this.isProfessionalMode,
